import { createSlice } from '@reduxjs/toolkit';
import { fetchExtAccountUsers } from './action';

const initialState = {
  isLoading: true,
  data: [],
};

const { reducer } = createSlice({
  name: 'externalAccountUsers',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchExtAccountUsers.pending]: (state, { meta }) => {
      const { arg: { background = false } = {} } = meta;
      if (background) return;
      state.isLoading = true;
    },
    [fetchExtAccountUsers.fulfilled]: (state, { payload }) => {
      state.data = payload?.data?.users || [];
      state.isLoading = false;
    },
  },
});

export default reducer;
